import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-accent text-text-on-accent hover:bg-accent/90",
        secondary:
          "border-transparent bg-highlight text-text-on-highlight hover:bg-highlight/90",
        destructive:
          "border-transparent bg-delete text-text-on-accent hover:bg-delete-hover",
        outline: "border-ui-border text-ui-foreground",
        accent:
          "border-transparent bg-tag-accent text-tag-accent-fg",
        muted:
          "border-transparent bg-tag-muted text-tag-muted-fg",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

/** Compact status or count label. */
function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
